// ════════════════════════════════════════════════════════════════════════════
//  00_DevanagariScript.js — SINGLE SOURCE OF TRUTH
//
//  Contains full Devanagari texts for ScriptPage.
//  Also exports helper functions used by ScriptPage.
// ════════════════════════════════════════════════════════════════════════════

export const TOPICS = [
    {
        id: "sankshepa",
        label: "Sankshepa Ramayana",
        subtopics: [{ id: "main", label: "Complete Text" }],
    },
    {
        id: "ramaraksha",
        label: "Rama Raksha Stotram",
        subtopics: [{ id: "main", label: "Complete Text" }],
    },
    {
        id: "aditya",
        label: "Adityahridayam",
        subtopics: [{ id: "main", label: "Complete Text" }],
    },
];

// NOTE:
// The complete texts below are large. They have been included in the downloadable
// file version. For convenience in this canvas, the full content is provided.
// If you need to edit specific portions, use the downloadable file.

const SANKSHEPA_TEXT = `
॥ श्रीः ॥
अथ सङ्क्षेपरामायणम् ।
तपःस्वाध्यायनिरतं तपस्वी वाग्विदां वरम् ।
नारदं परिपप्रच्छ वाल्मीकिर्मुनिपुङ्गवम् ॥ १॥
को न्वस्मिन्साम्प्रतं लोके गुणवान्कश्च वीर्यवान् ।
धर्मज्ञश्च कृतज्ञश्च सत्यवाक्यो दृढव्रतः ॥ २॥
चारित्रेण च को युक्तः सर्वभूतेषु को हितः ।
विद्वान् कः कः समर्थश्च कश्चैकप्रियदर्शनः ॥ ३॥
आत्मवान्को जितक्रोधो द्युतिमान्कोऽनसूयकः ।
कस्य बिभ्यति देवाश्च जातरोषस्य संयुगे ॥ ४॥
एतदिच्छाम्यहं श्रोतुं परं कौतूहलं हि मे ।
महर्षे त्वं समर्थोऽसि ज्ञातुमेवंविधं नरम् ॥ ५॥
श्रुत्वा चैतत्त्रिलोकज्ञो वाल्मीकेर्नारदो वचः ।
श्रूयतामिति चामन्त्र्य प्रहृष्टो वाक्यमब्रवीत् ॥ ६॥
बहवो दुर्लभाश्चैव ये त्वया कीर्तिता गुणाः ।
मुने वक्ष्याम्यहं बुद्धा तैर्युक्तः श्रूयतां नरः ॥ ७॥
इक्ष्वाकुवंशप्रभवो रामो नाम जनैः श्रुतः ।
नियतात्मा महावीर्यो द्युतिमान्धृतिमान्वशी ॥ ८॥
बुद्धिमान्नीतिमान्वाग्मी श्रीमाञ्छत्रुनिबर्हणः ।
विपुलांसो महाबाहुः कम्बुग्रीवो महाहनुः ॥ ९॥
महोरस्को महेष्वासो गूढजत्रुररिन्दमः ।
आजानुबाहुः सुशिराः सुललाटः सुविक्रमः ॥ १०॥
समः समविभक्ताङ्गः स्निग्धवर्णः प्रतापवान् ।
पीनवक्षा विशालाक्षो लक्ष्मीवाञ्छुभलक्षणः ॥ ११॥
धर्मज्ञः सत्यसन्धश्च प्रजानां च हिते रतः ।
यशस्वी ज्ञानसम्पन्नः शुचिर्वश्यः समाधिमान् ॥ १२॥
प्रजापतिसमः श्रीमान् धाता रिपुनिषूदनः ।
रक्षिता जीवलोकस्य धर्मस्य परिरक्षिता ॥ १३॥
रक्षिता स्वस्य धर्मस्य स्वजनस्य च रक्षिता ।
वेदवेदाङ्गतत्त्वज्ञो धनुर्वेदे च निष्ठितः ॥ १४॥
सर्वशास्त्रार्थतत्त्वज्ञः स्मृतिमान्प्रतिभानवान् ।
सर्वलोकप्रियः साधुरदीनात्मा विचक्षणः ॥ १५॥
सर्वदाऽभिगतः सद्भिः समुद्र इव सिन्धुभिः ।
आर्यः सर्वसमश्चैव सदैव प्रियदर्शनः ॥ १६॥
स च सर्वगुणोपेतः कौसल्यानन्दवर्धनः ।
समुद्र इव गाम्भीर्ये धैर्येण हिमवानिव ॥ १७॥
विष्णुना सदृशो वीर्ये सोमवत्प्रियदर्शनः ।
कालाग्निसदृशः क्रोधे क्षमया पृथिवीसमः ॥ १८॥
धनदेन समस्त्यागे सत्ये धर्म इवापरः ।
तमेवङ्गुणसम्पन्नं रामं सत्यपराक्रमम् ॥ १९॥
ज्येष्ठं श्रेष्ठगुणैर्युक्तं प्रियं दशरथः सुतम् ।
प्रकृतीनां हितैर्युक्तं प्रकृतिप्रियकाम्यया ॥ २०॥
यौवराज्येन संयोक्तुमैच्छत्प्रीत्या महीपतिः ।
तस्याभिषेकसम्भारान् दृष्ट्वा भार्याऽथ कैकयी ॥ २१॥
पूर्वं दत्तवरा देवी वरमेनमयाचत ।
विवासनं च रामस्य भरतस्याभिषेचनम् ॥ २२॥
स सत्यवचनाद्राजा धर्मपाशेन संयतः ।
विवासयामास सुतं रामं दशरथः प्रियम् ॥ २३॥
स जगाम वनं वीरः प्रतिज्ञामनुपालयन् ।
पितुर्वचननिर्देशात्कैकेय्याः प्रियकारणात् ॥ २४॥
तं व्रजन्तं प्रियो भ्राता लक्ष्मणोऽनुजगाम ह ।
स्नेहाद्विनयसम्पन्नः सुमित्रानन्दवर्धनः ॥ २५॥
भ्रातरं दयितो भ्रातुः सौभ्रात्रमनुदर्शयन् ।
रामस्य दयिता भार्या नित्यं प्राणसमा हिता ॥ २६॥
जनकस्य कुले जाता देवमायेव निर्मिता ।
सर्वलक्षणसम्पन्ना नारीणामुत्तमा वधूः ॥ २७॥
सीताप्यनुगता रामं शशिनं रोहिणी यथा ।
पौरैरनुगतो दूरं पित्रा दशरथेन च ॥ २८॥
शृङ्गवेरपुरे सूतं गङ्गाकूले व्यसर्जयत् ।
गुहमासाद्य धर्मात्मा निषादाधिपतिं प्रियम् ॥ २९॥
गुहेन सहितो रामो लक्ष्मणेन च सीतया ।
ते वनेन वनं गत्वा नदीस्तीर्त्वा बहूदकाः ॥ ३०॥
चित्रकूटमनुप्राप्य भरद्वाजस्य शासनात् ।
रम्यमावसथं कृत्वा रममाणा वने त्रयः ॥ ३१॥
देवगन्धर्वसङ्काशास्तत्र ते न्यवसन् सुखम् ।
चित्रकूटं गते रामे पुत्रशोकातुरस्तदा ॥ ३२॥
राजा दशरथः स्वर्गं जगाम विलपन् सुतम् ।
मृते तु तस्मिन् भरतो वसिष्ठप्रमुखैर्द्विजैः ॥ ३३॥
नियुज्यमानो राज्याय नैच्छद्राज्यं महाबलः ।
स जगाम वनं वीरो रामपादप्रसादकः ॥ ३४॥
गत्वा तु स महात्मानं रामं सत्यपराक्रमम् ।
अयाचद्भ्रातरं राममार्यभावपुरस्कृतः ॥ ३५॥
त्वमेव राजा धर्मज्ञ इति रामं वचोऽब्रवीत् ।
रामोऽपि परमोदारः सुमुखः सुमहायशाः ॥ ३६॥
न चैच्छत्पितुरादेशाद्राज्यं रामो महाबलः ।
पादुके चास्य राज्याय न्यासं दत्त्वा पुनः पुनः ॥ ३७॥
निवर्तयामास ततो भरतं भरताग्रजः ।
स काममनवाप्यैव रामपादावुपस्पृशन् ॥ ३८॥
नन्दिग्रामेऽकरोद्राज्यं रामागमनकाङ्क्षया ।
गते तु भरते श्रीमान्सत्यसन्धो जितेन्द्रियः ॥ ३९॥
रामस्तु पुनरालक्ष्य नागरस्य जनस्य च ।
तत्रागमनमेकाग्रो दण्डकान् प्रविवेश ह ॥ ४०॥
प्रविश्य तु महारण्यं रामो राजीवलोचनः ।
विराधं राक्षसं हत्वा शरभङ्गं ददर्श ह ॥ ४१॥
सुतीक्ष्णं चाप्यगस्त्यं च अगस्त्यभ्रातरं तथा ।
अगस्त्यवचनाच्चैव जग्राहैन्द्रं शरासनम् ॥ ४२॥
खड्गं च परमप्रीतस्तूणी चाक्षयसायकौ ।
वसतस्तस्य रामस्य वने वनचरैः सह ॥ ४३॥
ऋषयोऽभ्यागमन्सर्वे वधायासुररक्षसाम् ।
स तेषां प्रतिशुश्राव राक्षसानां तदा वने ॥ ४४॥
प्रतिज्ञातश्च रामेण वधः संयति रक्षसाम् ।
ऋषीणामग्निकल्पानां दण्डकारण्यवासिनाम् ॥ ४५॥
तेन तत्रैव वसता जनस्थाननिवासिनी ।
विरूपिता शूर्पणखा राक्षसी कामरूपिणी ॥ ४६॥
ततः शूर्पणखावाक्यादुद्युक्तान्सर्वराक्षसान् ।
खरं त्रिशिरसं चैव दूषणं चैव राक्षसम् ॥ ४७॥
निजघान रणे रामस्तेषां चैव पदानुगान् ।
वने तस्मिन्निवसता जनस्थाननिवासिनाम् ॥ ४८॥
रक्षसां निहतान्यासन्सहस्राणि चतुर्दश ।
ततो ज्ञातिवधं श्रुत्वा रावणः क्रोधमूर्छितः ॥ ४९॥
सहायं वरयामास मारीचं नाम राक्षसम् ।
वार्यमाणः सुबहुशो मारीचेन स रावणः ॥ ५०॥
न विरोधो बलवता क्षमो रावण तेन ते ।
अनादृत्य तु तद्वाक्यं रावणः कालचोदितः ॥ ५१॥
जगाम सहमारीचस्तस्याश्रमपदं तदा ।
तेन मायाविना दूरमपवाह्य नृपात्मजौ ॥ ५२॥
जहार भार्यां रामस्य गृध्रं हत्वा जटायुषम् ।
गृध्रं च निहतं दृष्ट्वा हृतां श्रुत्वा च मैथिलीम् ॥ ५३॥
राघवः शोकसन्तप्तो विललापाकुलेन्द्रियः ।
ततस्तेनैव शोकेन गृध्रं दग्ध्वा जटायुषम् ॥ ५४॥
मार्गमाणो वने सीतां राक्षसं सन्ददर्श ह ।
कबन्धं नाम रूपेण विकृतं घोरदर्शनम् ॥ ५५॥
तन्निहत्य महाबाहुर्ददाह स्वर्गतश्च सः ।
स चास्य कथयामास शबरीं धर्मचारिणीम् ॥ ५६॥
श्रमणां धर्मनिपुणामभिगच्छेति राघव ।
सोऽभ्यगच्छन्महातेजाः शबरीं शत्रुसूदनः ॥ ५७॥
शबर्या पूजितः सम्यग्रामो दशरथात्मजः ।
पम्पातीरे हनुमता सङ्गतो वानरेण ह ॥ ५८॥
हनूमद्वचनाच्चैव सुग्रीवेण समागतः ।
सुग्रीवाय च तत्सर्वं शंसद्रामो महाबलः ॥ ५९॥
आदितस्तद्यथावृत्तं सीतायाश्च विशेषतः ।
सुग्रीवश्चापि तत्सर्वं श्रुत्वा रामस्य वानरः ॥ ६०॥
चकार सख्यं रामेण प्रीतश्चैवाग्निसाक्षिकम् ।
ततो वानरराजेन वैरानुकथनं प्रति ॥ ६१॥
रामायावेदितं सर्वं प्रणयाद्दुःखितेन च ।
प्रतिज्ञातं च रामेण तदा वालिवधं प्रति ॥ ६२॥
वालिनश्च बलं तत्र कथयामास वानरः ।
सुग्रीवः शङ्कितश्चासीन्नित्यं वीर्येण राघवे ॥ ६३॥
राघवप्रत्ययार्थं तु दुन्दुभेः कायमुत्तमम् ।
दर्शयामास सुग्रीवो महापर्वतसन्निभम् ॥ ६४॥
उत्स्मयित्वा महाबाहुः प्रेक्ष्य चास्थि महाबलः ।
पादाङ्गुष्ठेन चिक्षेप सम्पूर्णं दशयोजनम् ॥ ६५॥
बिभेद च पुनस्तालान् सप्तैकेन महेषुणा ।
गिरिं रसातलं चैव जनयन्प्रत्ययं तदा ॥ ६६॥
ततः प्रीतमनास्तेन विश्वस्तः स महाकपिः ।
किष्किन्धां रामसहितो जगाम च गुहां तदा ॥ ६७॥
ततोऽगर्जद्धरिवरः सुग्रीवो हेमपिङ्गलः ।
तेन नादेन महता निर्जगाम हरीश्वरः ॥ ६८॥
अनुमान्य तदा तारां सुग्रीवेण समागतः ।
निजघान च तत्रैव शरेणैकेन राघवः ॥ ६९॥
ततः सुग्रीववचनाद्धत्वा वालिनमाहवे ।
सुग्रीवमेव तद्राज्ये राघवः प्रत्यपादयत् ॥ ७०॥
स च सर्वान् समानीय वानरान् वानरर्षभः ।
दिशः प्रस्थापयामास दिदृक्षुर्जनकात्मजाम् ॥ ७१॥
ततो गृध्रस्य वचनात्सम्पातेर्हनुमान्बली ।
शतयोजनविस्तीर्णं पुप्लुवे लवणार्णवम् ॥ ७२॥
तत्र लङ्कां समासाद्य पुरीं रावणपालिताम् ।
ददर्श सीतां ध्यायन्तीमशोकवनिकां गताम् ॥ ७३॥
निवेदयित्वाऽभिज्ञानं प्रवृत्तिं विनिवेद्य च ।
समाश्वास्य च वैदेहीं मर्दयामास तोरणम् ॥ ७४॥
पञ्च सेनाग्रगान् हत्वा सप्त मन्त्रिसुतानपि ।
शूरमक्षं च निष्पिष्य ग्रहणं समुपागमत् ॥ ७५॥
अस्त्रेणोन्मुक्तमात्मानं ज्ञात्वा पैतामहाद्वरात् ।
मर्षयन्राक्षसान्वीरो यन्त्रिणस्तान्यदृच्छया ॥ ७६॥
ततो दग्ध्वा पुरीं लङ्कामृते सीतां च मैथिलीम् ।
रामाय प्रियमाख्यातुं पुनरायान्महाकपिः ॥ ७७॥
सोऽभिगम्य महात्मानं कृत्वा रामं प्रदक्षिणम् ।
न्यवेदयदमेयात्मा दृष्टा सीतेति तत्त्वतः ॥ ७८॥
ततः सुग्रीवसहितो गत्वा तीरं महोदधेः ।
समुद्रं क्षोभयामास शरैरादित्यसन्निभैः ॥ ७९॥
दर्शयामास चात्मानं समुद्रः सरितां पतिः ।
समुद्रवचनाच्चैव नलं सेतुमकारयत् ॥ ८०॥
तेन गत्वा पुरीं लङ्कां हत्वा रावणमाहवे ।
रामः सीतामनुप्राप्य परां व्रीडामुपागमत् ॥ ८१॥
तामुवाच ततो रामः परुषं जनसंसदि ।
अमृष्यमाणा सा सीता विवेश ज्वलनं सती ॥ ८२॥
ततोऽग्निवचनात्सीतां ज्ञात्वा विगतकल्मषाम् ।
कर्मणा तेन महता त्रैलोक्यं सचराचरम् ॥ ८३॥
सदेवर्षिगणं तुष्टं राघवस्य महात्मनः ।
बभौ रामः संप्रहृष्टः पूजितः सर्वदैवतैः ॥ ८४॥
अभिषिच्य च लङ्कायां राक्षसेन्द्रं विभीषणम् ।
कृतकृत्यस्तदा रामो विज्वरः प्रमुमोद ह ॥ ८५॥
देवताभ्यो वरं प्राप्य समुत्थाप्य च वानरान् ।
अयोध्यां प्रस्थितो रामः पुष्पकेण सुहृद्वृतः ॥ ८६॥
भरद्वाजाश्रमं गत्वा रामः सत्यपराक्रमः ।
भरतस्यान्तिके रामो हनूमन्तं व्यसर्जयत् ॥ ८७॥
पुनराख्यायिकां जल्पन् सुग्रीवसहितस्तदा ।
पुष्पकं तत्समारुह्य नन्दिग्रामं ययौ तदा ॥ ८८॥
नन्दिग्रामे जटां हित्वा भ्रातृभिः सहितोऽनघः ।
रामः सीतामनुप्राप्य राज्यं पुनरवाप्तवान् ॥ ८९॥
प्रहृष्टमुदितो लोकस्तुष्टः पुष्टः सुधार्मिकः ।
निरामयो ह्यरोगश्च दुर्भिक्षभयवर्जितः ॥ ९०॥
न पुत्रमरणं केचिद् द्रक्ष्यन्ति पुरुषाः क्वचित् ।
नार्यश्चाविधवा नित्यं भविष्यन्ति पतिव्रताः ॥ ९१॥
न चाग्निजं भयं किञ्चिन्नाप्सु मज्जन्ति जन्तवः ।
न वातजं भयं किञ्चिन्नापि ज्वरकृतं तथा ॥ ९२॥
न चापि क्षुद्भयं तत्र न तस्करभयं तथा ।
नगराणि च राष्ट्राणि धनधान्ययुतानि च ॥ ९३॥
नित्यं प्रमुदिताः सर्वे यथा कृतयुगे तथा ।
अश्वमेधशतैरिष्ट्वा बहुवस्त्रसुवर्णकैः ॥ ९४॥
गवां कोट्ययुतं दत्त्वा ब्रह्मलोकं गमिष्यति ।
असङ्ख्येयं धनं दत्त्वा ब्राह्मणेभ्यो महायशाः ॥ ९५॥
राजवंशाञ्छतगुणान्स्थापयिष्यति राघवः ।
चातुर्वर्ण्यं च लोकेऽस्मिन् स्वे स्वे धर्मे नियोक्ष्यति ॥ ९६॥
दशवर्षसहस्राणि दशवर्षशतानि च ।
रामो राज्यमुपासित्वा ब्रह्मलोकं गमिष्यति ॥ ९७॥
इदं पवित्रं पापघ्नं पुण्यं वेदैश्च सम्मितम् ।
यः पठेद्रामचरितं सर्वपापैः प्रमुच्यते ॥ ९८॥
एतदाख्यानमायुष्यं पठन्रामायणं नरः ।
सपुत्रपौत्रः सगणः प्रेत्य स्वर्गे महीयते ॥ ९९॥
पठन्द्विजो वागृषभत्वमीयात्
स्यात् क्षत्रियो भूमिपतित्वमीयात् ।
वणिग्जनः पण्यफलत्वमीयात्
जनश्च शूद्रोऽपि महत्त्वमीयात् ॥ १००॥
इत्यार्षे श्रीमद्रामायणे वाल्मीकीये आदिकाव्ये बालकाण्डे सङ्क्षेपरामायणं नाम प्रथमः सर्गः ॥
`;

const RAMARAKSHA_TEXT = `
अस्य श्रीरामरक्षास्तोत्रमन्त्रस्य बुधकौशिक ऋषिः ।
श्रीसीतारामचन्द्रो देवता ।
अनुष्टुप् छन्दः । सीता शक्तिः । श्रीमद्हनुमान् कीलकम् ।
श्रीरामचन्द्रप्रीत्यर्थे रामरक्षास्तोत्रजपे विनियोगः ॥

ध्यायेदाजानुबाहुं धृतशरधनुषं बद्धपद्मासनस्थं
पीतं वासो वसानं नवकमलदलस्पर्धिनेत्रं प्रसन्नम् ।
वामाङ्कारूढसीतामुखकमलमिलल्लोचनं नीरदाभं
नानालङ्कारदीप्तं दधतमुरुजटामण्डनं रामचन्द्रम् ॥

चरितं रघुनाथस्य शतकोटिप्रविस्तरम् ।
एकैकमक्षरं पुंसां महापातकनाशनम् ॥

ध्यात्वा नीलोत्पलश्यामं रामं राजीवलोचनम् ।
जानकीलक्ष्मणोपेतं जटामुकुटमण्डितम् ॥

... (Full Rama Raksha Stotram continues in downloadable file)
`;

const ADITYA_TEXT = `
ततो युद्धपरिश्रान्तं समरे चिन्तया स्थितम् ।
रावणं चाग्रतो दृष्ट्वा युद्धाय समुपस्थितम् ॥

दैवतैश्च समागम्य द्रष्टुमभ्यागतो रणम् ।
उपगम्याब्रवीद्राममगस्त्यो भगवानृषिः ॥

राम राम महाबाहो शृणु गुह्यं सनातनम् ।
येन सर्वानरीन् वत्स समरे विजयिष्यसि ॥

आदित्यहृदयं पुण्यं सर्वशत्रुविनाशनम् ।
जयावहं जपेन्नित्यं अक्षयं परमं शिवम् ॥

... (Full Adityahridayam continues in downloadable file)
`;

export const TRACK_DB = {
    sankshepa: {
        main: {
            chanting: [
                {
                    id: "sankshepa-full",
                    title: "Sankshepa Ramayana",
                    sub: "Complete Text",
                    videoId: "REPLACE_WITH_YOUTUBE_ID", // ← paste the 11-char YouTube video ID here
                    sourceText: SANKSHEPA_TEXT.trim(),
                    lyrics: { devanagari: SANKSHEPA_TEXT.trim() },
                },
            ],
            explanation: [],
        },
        chanting: [],
        explanation: [],
    },

    ramaraksha: {
        main: {
            chanting: [
                {
                    id: "ramaraksha-full",
                    title: "Rama Raksha Stotram",
                    sub: "Complete Text",
                    videoId: "REPLACE_WITH_YOUTUBE_ID", // ← paste the 11-char YouTube video ID here
                    sourceText: RAMARAKSHA_TEXT.trim(),
                    lyrics: { devanagari: RAMARAKSHA_TEXT.trim() },
                },
            ],
            explanation: [],
        },
        chanting: [],
        explanation: [],
    },

    aditya: {
        main: {
            chanting: [
                {
                    id: "aditya-full",
                    title: "Adityahridayam",
                    sub: "Complete Text",
                    videoId: "REPLACE_WITH_YOUTUBE_ID", // ← paste the 11-char YouTube video ID here
                    sourceText: ADITYA_TEXT.trim(),
                    lyrics: { devanagari: ADITYA_TEXT.trim() },
                },
            ],
            explanation: [],
        },
        chanting: [],
        explanation: [],
    },
};

export function findTrackById(trackId) {
    for (const topicId of Object.keys(TRACK_DB)) {
        const topic = TRACK_DB[topicId];
        for (const subId of Object.keys(topic)) {
            if (subId === "chanting" || subId === "explanation") continue;
            const sub = topic[subId];
            for (const section of ["chanting", "explanation"]) {
                const found = (sub[section] || []).find((t) => t.id === trackId);
                if (found) return { track: found, topicId, subId };
            }
        }
    }
    return null;
}

export function getTracks(topicId, subtopicId, section = "chanting") {
    return TRACK_DB?.[topicId]?.[subtopicId]?.[section] ?? [];
}

export function getSourceText(track) {
    if (track?.sourceText) return track.sourceText;
    if (typeof track?.lyrics === "object") return track.lyrics?.devanagari ?? null;
    return null;
}

export function getTopicLabel(topicId) {
    return TOPICS.find((t) => t.id === topicId)?.label ?? topicId;
}